import { useQuery } from "@tanstack/react-query";
import { getSourcingTypeEnums } from "@/apis/requirementManagement.api";
import type { SourcingType } from "@/types/apis";

type SourceNode = {
  desc: string;
  value: string | number;
  children?: SourceNode[];
};

type CascaderOption = {
  label: string;
  value: string | number;
  children?: CascaderOption[];
};

const transformToCascaderOptions = (data: SourceNode[]): CascaderOption[] => {
  return data.map((item) => ({
    label: item.desc,
    value: item.value,
    children: item.children
      ? transformToCascaderOptions(item.children)
      : undefined,
  }));
};

/**
 * 寻源类别查询 hook
 */
export function useSourcingTypeQuery() {
  const query = useQuery({
    queryKey: ["sourcingTypeEnums"],
    queryFn: getSourcingTypeEnums,
  });

  const cascaderSourcingTypeOptions = query.data?.data.data
    ? transformToCascaderOptions(query.data?.data.data)
    : [];

  /**
   * 根据寻源类别获取二级寻源列表
   * @param sourcingTypeValue 寻源类别值
   * @returns 二级寻源列表
   */
  const getSubSourcingTypeOptions = (sourcingTypeValue: string) => {
    const sourcingTypes = query.data?.data.data;
    if (!sourcingTypes) return [];
    const sourcingType = sourcingTypes.find(
      (item: SourcingType) => item.value.toString() === sourcingTypeValue,
    );
    return (
      sourcingType?.children.map((item) => ({
        label: item.desc,
        value: item.value,
      })) || []
    );
  };

  return {
    sourcingTypeOptions: query.data?.data.data.map((item) => ({
      label: item.desc,
      value: item.value.toString(),
    })),
    getSubSourcingTypeOptions,
    cascaderSourcingTypeOptions,
  };
}
